import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * Persistent bottom-anchored Apply CTA. Appears once the operator scrolls
 * past the hero and never leaves the sight-line on marketing pages.
 * Not used on /apply itself.
 */
export default function StickyApplyCta() {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const onScroll = () => {
			const y = window.scrollY;
			const h = window.innerHeight;
			// Show once the hero (~1 viewport) is largely off-screen.
			setVisible(y > h * 0.65);
		};
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<AnimatePresence>
			{visible && (
				<motion.a
					href="/apply"
					data-testid="sticky-apply-cta"
					initial={{ y: 100, x: "-50%", opacity: 0 }}
					animate={{ y: 0, x: "-50%", opacity: 1 }}
					exit={{ y: 100, x: "-50%", opacity: 0 }}
					transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
					className="fixed left-1/2 z-40 rounded-full flex items-center gap-3 shadow-[0_10px_30px_rgba(15,15,15,0.15)]"
					style={{
						bottom: "clamp(16px, 3vh, 32px)",
						background: "var(--bone)",
						color: "var(--obsidian)",
						padding: "12px 8px 12px 22px",
						border: "1px solid var(--bone)",
					}}
				>
					<span className="text-[13px] font-medium tracking-[-0.005em]">
						Cohort 1 is forming · <span className="opacity-70">1 of 3 seats open</span>
					</span>
					<span
						className="rounded-full px-4 py-1.5 text-[13px] font-semibold flex items-center gap-1.5"
						style={{ background: "var(--accent-green)", color: "var(--obsidian)" }}
					>
						Apply <span aria-hidden>→</span>
					</span>
				</motion.a>
			)}
		</AnimatePresence>
	);
}
